import React from 'react'
import classNames from 'classnames'

interface Props {
  className?: string
  borderRadiusClassName?: string
  hideTextPlaceholders?: boolean
  orientation?: 'portrait' | 'landscape'
  ref?: React.Ref<HTMLDivElement>
}

export const PlaceholderMediaCard = ({
  className = '',
  hideTextPlaceholders,
  borderRadiusClassName,
  orientation = 'landscape',
  ...rest
}: Props) => {
  return (
    <div {...rest} className={classNames('relative group animate-pulse', className)}>
      <div
        className={classNames(
          'w-full mb-1 bg-black',
          { 'pt-[56.25%]': orientation === 'landscape', 'pt-[160%]': orientation === 'portrait' },
          borderRadiusClassName,
        )}
      />
      {!hideTextPlaceholders && (
        <>
          <div className="h-[16.25px] w-1/2 rounded bg-black" />
          <div className="my-1 h-[24px] w-3/4 rounded bg-black" />
        </>
      )}
    </div>
  )
}
